module.exports = __webpack_public_path__ + "static/media/_latvia.4fd871ca.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/_latvia.svg
// module id = 2333
// module chunks = 7